import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
// import { useHistory, useParams } from "react-router-dom";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import ToolkitProvider, {
	CSVExport,
	Search,
} from "react-bootstrap-table2-toolkit";
import { developAxios } from "../axios.config";

const { SearchBar } = Search;
const { ExportCSVButton } = CSVExport;
const AlllTablequizresultsbybatch = () => {
	const { examId } = useParams();

	const [tabledata, settabledata] = useState([]);
	const [courseData, setCourseData] = useState([]);
	const [rowcount, setRowcount] = useState(0);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		setRowcount(tabledata.length);
	}, [tabledata]);

	useEffect(() => {
		if (!examId) return;

		developAxios(localStorage.getItem("token"))
			.post("/admin/quiz/get-results", {
				examIds: [examId],
			})
			.then(({ data }) => {
				setCourseData(data.results);
			})
			.catch((err) => {
				console.error(err.response);
			});
	}, [examId]);

	useEffect(() => {
		let newdata = [];
		for (var i = 0; i < courseData.length; i++) {
			let correctdate = new Date(
				courseData[i]?.submit_date
			).toLocaleString();
			newdata.push({
				sno: i + 1,
				email: courseData[i]?.email,
				questionattempted: courseData[i]?.questions_Attempted.length,
				finalscore: courseData[i]?.finalScore,
				submitdate: correctdate.split(",")[0],
				submittime: correctdate.split(",")[1],
				examName: courseData[i]?.examId?.examName,
				tabsopened: courseData[i].tabsopened || 0,
			});
		}
		settabledata(newdata);
		//   console.log(JSON.stringify(newdata));
	}, [courseData]);

	// let priceFilter;

	const columns = [
		{
			dataField: "sno",
			text: "S no.",
			sort: true,
			headerStyle: () => {
				return { width: "5%", backgroundColor: "#133d6a" };
			},
		},
		{
			dataField: "email",
			text: "Email",
			sort: true,
			filter: textFilter(),
			headerStyle: () => {
				return { width: "10%", backgroundColor: "#133d6a" };
			},
		},

		{
			dataField: "questionattempted",
			text: "Questions Attempted",
			sort: true,
			filter: textFilter(),
			headerStyle: () => {
				return { width: "10%", backgroundColor: "#133d6a" };
			},
		},

		{
			dataField: "finalscore",
			text: "Final Score",
			sort: true,
			filter: textFilter(),
			headerStyle: () => {
				return { width: "10%", backgroundColor: "#133d6a" };
			},
		},
		{
			dataField: "submitdate",
			text: "Submit Date",
			sort: true,
			filter: textFilter(),
			headerStyle: () => {
				return { width: "10%", backgroundColor: "#133d6a" };
			},
		},
		{
			dataField: "submittime",
			text: "Submit Time",
			sort: true,
			filter: textFilter(),
			headerStyle: () => {
				return { width: "10%", backgroundColor: "#133d6a" };
			},
		},
		{
			dataField: "examName",
			text: "Exam Name",
			sort: true,
			filter: textFilter(),
			headerStyle: () => {
				return { width: "10%", backgroundColor: "#133d6a" };
			},
		},
		{
			dataField: "tabsopened",
			text: "Tab Switches",
			sort: true,
			headerStyle: () => {
				return { width: "6%", backgroundColor: "#133d6a" };
			},
		},
	];
	const handleDataChange = ({ dataSize }) => {
		setRowcount(dataSize);
	};

	const numberStyle = {
		border: "2px solid black",
		boxShadow: "4px 4px rgba(93, 93, 93)",
		borderRadius: "20px",
		fontFamily: "Poppins-Bold",
		color: "white",
	};

	function downloadQuizData() {
		setLoading(true);
		fetch(
			`${
				process.env.REACT_APP_BASE_URL
			}/${`downloadSubmittedUsersByExamId_quiz`}/${examId}`,
			{
				headers: {
					Authorization: `Bearer ${
						localStorage.getItem("token") || ""
					}`,
				},
			}
		)
			.then((res) => res.blob())
			.then((blob) => {
				const url = window.URL.createObjectURL(new Blob([blob]));
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", `quizResult_${examId}_file.xlsx`);
				document.body.appendChild(link);
				link.click();
			})
			.catch((err) => {
				alert(`Unable to download file quizResult_${examId}_file.xlsx`);
			})
			.finally(() => setLoading(false));
	}
	return (
		<>
			<div className="text-centre my-4">
				<h1
					style={{
						fontFamily: "Poppins-Bold",
						color: "#185adb",
						textAlign: "center",
					}}
				>
					Exam Results
					<br />
				</h1>
			</div>

			<div className="mx-2 w-25 p-3 bg-dark " style={numberStyle}>
				Row Count:<span style={{ color: "yellow" }}>{rowcount}</span>
			</div>
			<div className="text-center my-3">
				<ToolkitProvider
					keyField={"sno"}
					data={tabledata}
					columns={columns}
					exportCSV={{
						fileName: "scores_results.csv",
						blobType: "text/csv;charset=ansi",
						onlyExportFiltered: true,
						exportAll: false,
					}}
					search
				>
					{(props) => (
						<div>
							<div className="d-flex justify-content-between">
								<button
									className="btn btn-md bg-warning my-2 "
									style={{
										borderRadius: "10px",
										marginLeft: "20px",
									}}
									onClick={downloadQuizData}
									disabled={loading}
								>
									Download All Data
								</button>
								<SearchBar
									{...props.searchProps}
									style={{
										width: "300px",
										height: "5px",
										marginRight: "20px",
									}}
								/>
							</div>
							<br />
							<BootstrapTable
								{...props.baseProps}
								filter={filterFactory()}
								onDataSizeChange={handleDataChange}
								// condensed
								bootstrap4
								loading
								// classes="text-white"
								striped
							/>
						</div>
					)}
				</ToolkitProvider>
			</div>
		</>
	);
};

export default AlllTablequizresultsbybatch;
